import React, { useEffect } from 'react';
import { X, UserPlus } from 'lucide-react';
import ContactCreateForm from './ContactCreateForm';
import { getContactContextLabel } from '../utils/companyDisplayName';

/**
 * Fase 2 (Contatos C4) — wrapper modal do ContactCreateForm.
 *
 * Padrão visual coerente com EmpresaQuickViewModal e ContactVCardQR:
 * fundo semi-transparente, card branco com header colorido, fecha via
 * X / clique fora / Esc. Toast de sucesso é window.alert simples (não há
 * sistema de toast no projeto ainda).
 */
const ContactQuickAddModal = ({ empresa, onClose, onCreated }) => {
  useEffect(() => {
    const onEsc = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [onClose]);

  const handleSuccess = (result) => {
    const action = result?.linked_existing ? 'vinculado' : 'criado';
    const label = getContactContextLabel(result?.empresa, result?.contact);
    // Toast simples (nenhum sistema de toast existe no projeto; alert é o
    // comportamento já usado em outros fluxos críticos do Dashboard).
    window.alert(`Contato ${action}: ${label}`);
    onCreated?.(result);
    onClose?.();
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Novo contato"
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-slate-50">
          <div className="flex items-center gap-2">
            <UserPlus size={16} className="text-indigo-600" />
            <h3 className="text-sm font-semibold text-slate-800">Novo contato</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fechar"
            className="p-1 rounded hover:bg-slate-200 text-slate-500"
          >
            <X size={16} />
          </button>
        </div>

        <div className="p-4">
          <ContactCreateForm
            source="manual"
            preSelectedEmpresa={empresa || null}
            onSuccess={handleSuccess}
            onCancel={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactQuickAddModal;
